import type { ReactNode } from 'react';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/pro-light-svg-icons';
import { ButtonMain } from '@quero-delivery/quero-components-web';
import { createPortal } from 'react-dom';

import styles from './styles.module.scss';

import useModal from '@/hooks/util/useModal';
import { colors } from '@/Themes/Colors';
import PurpleButton from '../../shared/purple-button/PurpleButton';

export interface IConfirmationProps {
  open: boolean;
  onRefuse(): void;
  onConfirm(): void;
  closeOnDimerClick?: boolean;
  closeIcon?: boolean;
  children?: ReactNode;
  isAlert?: boolean;
  acceptText?: string | ReactNode;
  refuseText?: string | ReactNode;
  size?: number;
}

function Confirmation({
  open,
  closeIcon = true,
  closeOnDimerClick = true,
  children,
  onConfirm,
  onRefuse,
  isAlert = false,
  acceptText = <b>sim</b>,
  refuseText = <b>cancelar</b>,
  size = 28.125,
}: IConfirmationProps) {
  const Modal = useModal({ maxHeight: undefined });

  if (!open) return null;

  return createPortal(
    <Modal
      onClose={onRefuse}
      open={open}
      closeOnDimerClick={closeOnDimerClick}
      closeIcon={closeIcon}
      width={`${size}rem`}
      noBorder
      className={styles.confirmation}
    >
      {isAlert && (
        <div className={styles.alert}>
          <FontAwesomeIcon
            icon={faExclamationCircle}
            color={colors.brand10}
            size="4x"
          />
          <h4>
            <b>Atenção</b>
          </h4>
        </div>
      )}

      {children}

      <div className={styles.actions}>
        <ButtonMain secondary onClick={onRefuse}>
          {refuseText}
        </ButtonMain>

        <PurpleButton onClick={onConfirm}>{acceptText}</PurpleButton>
      </div>
    </Modal>,
    document.body,
  );
}

export default Confirmation;
